import { OrganizationVideo } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import React from 'react';
import { NewModal } from '../NewModal';
import { OrganizationVideoForm } from './OrganizationVideoForm';

type ModalProps = {
  handleModalClose: () => void;
  organizationVideo?: OrganizationVideo;
};

export const ModalOrganizationVideoForm = ({
  handleModalClose,
  organizationVideo,
}: ModalProps) => {
  const isEdit = !!organizationVideo;
  return (
    <NewModal
      closeModal={handleModalClose}
      headerText={isEdit ? organizationVideo?.title : 'Add Organization Video'}
      style={{
        content: { maxWidth: '900px', minWidth: '900px', maxHeight: '90vh' },
      }}
      hideCloseButtonInHeader
      closeModalOnBackdropOrEscPress={false}
    >
      <OrganizationVideoForm
        organizationVideo={organizationVideo}
        onSuccess={handleModalClose}
      />
    </NewModal>
  );
};
